import React from "react";
import { flagsAndExperimentNames, useOnLoadFlagOrExperiment } from "../hoc/with-flags-and-experiments";
import GridFilterSizeSelector from "./grid-filter-modal-size-selector";

export type CoreFiltersProps = {
  onSubmitFilters: () => void;
};

const CoreFilters = ({ onSubmitFilters }: CoreFiltersProps) => {
  const [coreFilterFlag] = useOnLoadFlagOrExperiment(flagsAndExperimentNames.RESERVE_FILTER);

  if (!coreFilterFlag) {
    return null;
  }

  const renderHeader = () => {
    return (
      <div className="flex justify-between py-3 border-b border-solid border-lighterGray">
        <div className="text-lg">Rental Preferences</div>
        <div>Zip Placeholder</div>
      </div>
    );
  };

  const renderAvailabilityToggle = () => <div className="py-2 text-md">Availability Toggle Placeholder</div>;
  const renderReserveDatepicker = () => <div className="py-2 text-md">Reserve Datepicker Placeholder</div>;

  return (
    <div className="mx-6 my-4 px-3 py-2 border border-solid rounded-md">
      {renderHeader()}
      <div className="my-2">
        <GridFilterSizeSelector onSubmitFilters={onSubmitFilters} />
        {renderAvailabilityToggle()}
        {renderReserveDatepicker()}
      </div>
    </div>
  );
};

export default CoreFilters;
